import { CartProductDto } from "./cartProduct.dto";

export class WebPosMoveTableRequestDto {
  public originCartId: number;
  public originSaleUnitId: number;
  public originSaleUnitCartId: number;
  public targetTableIsOpen: boolean;
  public targetSaleUnitId: number;
  public cartProducts: CartProductDto[];
  public moveAllProducts: boolean;
  public originCovers: number;
  public targetCartId?: number;
  public customerId?: number;
  public posDeviceId?: number;
  public operatorEmployeeId?: number;

  constructor(
    originCartId: number,
    originSaleUnitId: number,
    originSaleUnitCartId: number,
    targetTableIsOpen: boolean,
    targetSaleUnitId: number,
    cartProducts: CartProductDto[],
    moveAllProducts: boolean,
    originCovers: number,
    targetCartId?: number,
    customerId?: number,
    posDeviceId?: number,
    operatorEmployeeId?: number
  ) {
    this.originCartId = originCartId;
    this.originSaleUnitId = originSaleUnitId;
    this.originSaleUnitCartId = originSaleUnitCartId;
    this.targetTableIsOpen = targetTableIsOpen;
    this.targetSaleUnitId = targetSaleUnitId;
    this.cartProducts = cartProducts;
    this.originCovers = originCovers;
    this.moveAllProducts = moveAllProducts;
    this.targetCartId = targetCartId;
    this.customerId = customerId;
    this.posDeviceId = posDeviceId;
    this.operatorEmployeeId = operatorEmployeeId;
  }
}
